module.exports = __webpack_public_path__ + "static-v-shop/1765575532973/img/ic-tips.6f923265.png";